/**
 * 课程学习抓拍记录
 */

export const CourseRecordSnapList = [
  {
    prop: "userName",
    label: "用户名称",
    width: "150",
    isShow: true,
  },
  {
    prop: "phone",
    label: "手机号",
    width: "150",
    isShow: true,
  },
  {
    prop: "courseTitile",
    label: "课程名称",
    width: "200",
    isShow: true,
  },
  {
    prop: "courseChapterTitle",
    label: "章节名称",
    width: "200",
    isShow: true,
  },
  {
    prop: "photographTime",
    label: "抓拍时间",
    width: "200",
    isShow: true,
    format: "datetime",
  },
  {
    prop: "photographScore",
    label: "抓拍得分",
    width: "200",
    isShow: true,
    format: "decimal",
  },
  {
    prop: "comparePhotograph",
    label: "身份证图片",
    width: "150",
    isShow: true,
    format: "image",
  },
  {
    prop: "studyPhotograph",
    label: "抓拍图片",
    width: "150",
    isShow: true,
    format: "image",
  },
  {
    prop: "photographResult",
    label: "抓拍结果",
    width: "150",
    isShow: true,
  },
];
